class CompareData {
    static detectTypeAndCompare(x, y) {
        const tx = typeof x, ty = typeof y;
        const isNullable = [
            x === null,
            y === null,
            tx === "undefined",
            ty === "undefined",
        ];
        if (isNullable.some(it => it))
            return x === y;
        if (CompareData.byScalar(x, y))
            return true;
        if (Array.isArray(x) && Array.isArray(x))
            return CompareData.byArray(x, y);
        if ((tx === "object" && ty === "object") && (!Array.isArray(x) && !Array.isArray(y)))
            return CompareData.byObject(x, y);
        return false;
    }
    static byScalar(x, y) {
        const scalar = ["string", "number", "undefined", "boolean"];
        return [scalar.includes(typeof x), scalar.includes(typeof y), x === y].every(item => item);
    }
    static byArray(x, y) {
        return x.length === y.length && x.every((item, i) => {
            return CompareData.detectTypeAndCompare(item, y[i]);
        });
    }
    static byObject(x, y) {
        const ok = Object.keys;
        const byLength = ok(x).length === ok(y).length;
        return byLength && ok(x).every((key) => {
            return CompareData.detectTypeAndCompare(x[key], y[key]);
        });
    }
    static isEquals(n1, n2) {
        return CompareData.detectTypeAndCompare(n1, n2);
    }
}
export default CompareData;
